import { Link } from "react-router-dom";
import { allSoftware, formatDownloads } from "@/utils/software";

const promises = [
  {
    icon: "ri-verified-badge-line",
    title: "正规资源收录",
    desc: "人工筛选主流黄金投资软件，信息清晰可查。",
  },
  {
    icon: "ri-download-cloud-2-line",
    title: "免费无门槛",
    desc: "全站软件均可免费获取，无需注册即可浏览。",
  },
  {
    icon: "ri-shield-check-line",
    title: "安全无捆绑",
    desc: "标注软件来源与版本信息，避免误装风险。",
  },
  {
    icon: "ri-refresh-line",
    title: "持续更新",
    desc: "跟随软件版本迭代，及时同步最新动态。",
  },
];

export default function CommitmentSection() {
  const totalDownloads = allSoftware.reduce((sum, item) => sum + item.downloads, 0);

  return (
    <section className="mt-12 border-y border-background-200 bg-background-100">
      <div className="container-page grid gap-10 py-14 lg:grid-cols-[1.05fr_1fr] lg:items-center">
        <div className="flex flex-col gap-4">
          <span className="chip w-fit bg-primary-100 text-primary-800">
            <i className="ri-information-line" />
            关于本下载站
          </span>
          <h2 className="font-heading text-2xl font-bold text-foreground-950 text-balance md:text-3xl">
            让每一位黄金投资者都能找到趁手的工具
          </h2>
          <p className="text-sm leading-relaxed text-foreground-600">
            黄金网站软件app免费专注于黄金投资领域的软件与 APP 推荐，覆盖行情分析、价格监控、理财配置与资讯获取等场景。我们以清晰的分类、真实的软件信息与友好的下载指引，帮助散户投资者和理财用户更高效地了解黄金市场，做出更从容的判断。
          </p>
          <div className="mt-1 flex flex-wrap gap-6">
            <div className="flex flex-col">
              <span className="font-heading text-2xl font-bold text-primary-700">
                {allSoftware.length}
              </span>
              <span className="text-xs text-foreground-500">收录软件（款）</span>
            </div>
            <div className="flex flex-col">
              <span className="font-heading text-2xl font-bold text-accent-600">
                {formatDownloads(totalDownloads)}
              </span>
              <span className="text-xs text-foreground-500">累计下载次数</span>
            </div>
            <div className="flex flex-col">
              <span className="font-heading text-2xl font-bold text-foreground-800">4</span>
              <span className="text-xs text-foreground-500">软件分类</span>
            </div>
          </div>
          <Link to="/about" className="btn-primary mt-2 w-fit">
            了解更多 <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          {promises.map((item) => (
            <div key={item.title} className="card-surface flex flex-col gap-2 p-5">
              <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary-500/15 text-2xl text-primary-700">
                <i className={item.icon} />
              </span>
              <h3 className="font-heading text-base font-bold text-foreground-900">
                {item.title}
              </h3>
              <p className="text-xs leading-relaxed text-foreground-600">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}